import { render, staticRenderFns } from "./DialogPerformanceVetuste.vue?vue&type=template&id=c242daf0&scoped=true&"
import script from "./DialogPerformanceVetuste.vue?vue&type=script&lang=js&"
export * from "./DialogPerformanceVetuste.vue?vue&type=script&lang=js&"
import style0 from "./DialogPerformanceVetuste.vue?vue&type=style&index=0&id=c242daf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c242daf0",
  null
  
)

export default component.exports